import React, { useEffect, useState } from "react";
import Joi from "joi-browser";

import MiniHero from "./../MiniHero";

function ContactUs({ homeRef, handleScroll }) {
  const schema = {
    name: Joi.string().required(),
    email: Joi.string().email({
      minDomainSegments: 2,
      tlds: { allow: ["com", "net"] },
    }),
    phone: Joi.number().required(),
    message: Joi.string().required(),
  };

  const [userContact, setUserContact] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitState, setSubmitState] = useState("not submitted");
  const [formErrors, setFormErrors] = useState({});
  const [propertyError, setPropertyError] = useState({});

  const validate = () => {
    const options = { abortEarly: true };
    const { error } = Joi.validate(userContact, schema, options);

    if (!error) {
      return null;
    }

    const errors = {};

    for (let item of error.details) errors[item.path[0]] = item.message;

    return errors;
  };

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schemaV = { [name]: schema[name] };
    const { error } = Joi.validate(obj, schemaV);
    return error ? error.details[0].message : null;
  };

  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    //setUserContact({ ...userContact, [e.target.name]: e.target.value });
    const errors = { ...propertyError };
    const errorMessage = validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    setPropertyError(errors);

    const contact = { ...userContact };
    contact[input.name] = input.value;
    setUserContact(contact);

    if (formErrors[input.name]) {
      delete formErrors[input.name];
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    setFormErrors(errors);
    if (errors) {
      return;
    }

    setSubmitState("submitting");
    setTimeout(() => {
      setSubmitState("submitted");
    }, 1000);
  };

  const inputStyle =
    "form-control boxshadow-none rounded-0 border-top-0 border-end-0 border-start-0";
  const inputInvalid = `${inputStyle} is-invalid`;
  return (
    <>
      <MiniHero
        homeRef={homeRef}
        onScroll={handleScroll}
        title="Contact Us"
        className="fs-48 text-dark mb-5"
      />
      <div className="container">
        <div className="w-100" style={{ marginTop: "-20px" }}>
          <div className="row">
            <div className="col-sm-12 col-md-5">
              <div className="w-100 mb-4 mb-sm-0">
                <h2 className="fs-1 mb-3">Tanaad Money Ltd</h2>
                <p className="mb-3">
                  <span className="d-block">
                    5 Red Lion Court, Alexandra Road,
                  </span>
                  <span className="d-block">Hounslow, England, TW3 1JS</span>
                </p>
                <p className="fs-16">
                  <span className="fw-bold me-2">Email:</span>
                  <a href="mailto: support@tanaad.com">support@tanaad.com</a>
                </p>
                <p className="fs-16 text-decoration-none">
                  <span className="fw-bold me-2">Call us on:</span>
                  <a href="tel: 02030703009">0203 070 3009</a>
                </p>
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <div className="w-100 px-2 py-4 shadow-sm rounded mb-5 min-height-460">
                {submitState === "not submitted" && (
                  <>
                    {" "}
                    <h3 className="fs-5 mb-5">
                      Please fill the form below to contact us. We will get back
                      to you as soon as possible.
                    </h3>
                    <form onSubmit={handleSubmit}>
                      <div className="w-100 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            name="name"
                            onChange={handleChange}
                            className={
                              formErrors && formErrors.name
                                ? inputInvalid
                                : inputStyle
                            }
                            id="floatingInput"
                            placeholder="Name"
                          />
                          <label htmlFor="floatingInput">Name</label>
                        </div>
                        {propertyError && propertyError.name && (
                          <div className="invalid-feedback d-block">
                            Name is not allowed to be empty.
                          </div>
                        )}
                      </div>
                      <div className="w-100 mb-3">
                        <div className="form-floating">
                          <input
                            type="email"
                            name="email"
                            onChange={handleChange}
                            className={
                              formErrors && formErrors.email
                                ? inputInvalid
                                : inputStyle
                            }
                            id="floatingInput"
                            placeholder="name@example.com"
                          />
                          <label htmlFor="floatingInput">Email</label>
                        </div>
                        {propertyError && propertyError.email && (
                          <div className="invalid-feedback d-block">
                            Please provide a valid email.
                          </div>
                        )}
                      </div>
                      <div className="w-100 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            name="phone"
                            onChange={handleChange}
                            className={
                              formErrors && formErrors.phone
                                ? inputInvalid
                                : inputStyle
                            }
                            id="floatingInput"
                            placeholder="Phone"
                          />
                          <label htmlFor="floatingInput">Phone</label>
                        </div>
                        {propertyError && propertyError.phone && (
                          <div className="invalid-feedback d-block">
                            Phone must be a number
                          </div>
                        )}
                      </div>
                      <div className="w-100 mb-3">
                        <div className="form-floating">
                          <textarea
                            name="message"
                            onChange={handleChange}
                            className="form-control boxshadow-none rounded-0 border-top-0 border-end-0 border-start-0 height-100"
                            placeholder="Leave a comment here"
                            id="floatingTextarea"
                          ></textarea>
                          <label htmlFor="floatingTextarea">Message</label>
                        </div>
                      </div>
                      <div className="mb-3 mt-5 d-grid gap-2">
                        <button className="btn btn-primary rounded-pill">
                          Submit
                        </button>
                      </div>
                    </form>
                  </>
                )}
                {submitState === "submitting" && (
                  <div className="w-100 height-400 d-flex align-items-center justify-content-center">
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>
                )}
                {submitState === "submitted" && (
                  <div className="w-100 height-400 d-flex align-items-center justify-content-center">
                    <p>
                      Thank you for contacting. Our team will get back to you
                      soon.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
